module.exports = __webpack_public_path__ + "img/gz.06d4baf6.png";